import React from 'react'

import { Label, Switch, Slider } from './ToggleSwitchStyled'

interface ToggleSwitchProps {
  name: string
  isOn?: boolean
  save: () => void
  colors: any
}

export default function ToggleSwitch({
  name,
  isOn,
  save,
  colors
}: ToggleSwitchProps) {
  return (
    <Label
      onMouseUp={() => {
        // sound();
        save()
      }}
    >
      <h3>{name}</h3>
      <Switch  colors={colors} className='switch' >
        <input defaultChecked={isOn} type='checkbox' />
        <Slider colors={colors} className='slider' />
      </Switch>
    </Label>
  )
}
